import AlertConfigOption from "./AlertConfigOption";
import { FaClock } from "react-icons/fa6";
import { useState } from "react";
import { useSelector } from "react-redux";
import SignalTimeFrameModal from "./SignalTimeFrameModal";

const displayFrequency = {
  "1H": "Hourly",
  "3H": "3 Hours",
  "2H": "2 Hours",
  "4H": "4 Hours",
  "6H": "6 Hours",
  "12H": "12 Hours",
  "1D": "Daily",
  "4D": "Twice a week",
  "7D": "Weekly",
  "14D": "Biweekly",
  "28D": "Monthly",
};

function AlertFrequencyBox() {
  const [openConfigModal, setOpenConfigModal] = useState(false);

  const { alertStatus } = useSelector((state) => state.alertSystem);

  return (
    <AlertConfigOption
      icon={<FaClock />}
      title="Alert Frequency"
      onClick={() => setOpenConfigModal(true)}
    >
      <p>
        Currently:{" "}
        <span>
          {displayFrequency[alertStatus?.alert_frequency] ||
            alertStatus?.alert_frequency}
        </span>
      </p>

      {openConfigModal && (
        <SignalTimeFrameModal
          visible={openConfigModal}
          onClose={() => setOpenConfigModal(false)}
        />
      )}
    </AlertConfigOption>
  );
}

export default AlertFrequencyBox;
